import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import {
  deleteCharitableOrgById,
  fetchCharitableOrgs,
  restoreCharitableOrg,
  searchCharitableOrg,
  toggleOrgStatus,
} from "../../services/axios/apiManager";
// import AddEditOrganizationModal from "./AddOrganization";
// import OrganizationDetailsModal from "./organizationDetails";
import LoadingSpinner from "../../Components/spinner";
import BSPagination from "../../Components/pagination";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
const OrganizationList = ({
  charitableOrgs,
  setCharitableOrgs,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [selectedOrganization, setSelectedOrganization] = useState({});
  const [orgForDetails, setOrgForDetails] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [query, setQuery] = useState("");
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [filters, setFilters] = useState("4");
  const tableRef = useRef(null);

  // // // Fetch Organizations List
  const fetchOrgs = async (pgntn, str = "") => {
    setFiltering(true);
    const res = await fetchCharitableOrgs(
      pgntn?.currentPage || 1,
      pgntn?.pageSize || 20,
      str
    );
    if (res?.data?.success && res?.data?.data) {
      setCharitableOrgs(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    setFiltering(false);
  };

  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  const fetchFilteredOrgs = async (e) => {
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchOrgs(pagination, string);
  };

  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    await fetchOrgs(pagination);
  };

  // // //Search Organizations Logic
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    setFilters("4");
    if (string.length > 0) {
      setFiltering(true);
      const res = await searchCharitableOrg(string);
      if (res?.data?.data) {
        setCharitableOrgs(res.data.data);
      } else {
        handleErrors(res, navigate);
      }
    } else {
      await fetchOrgs(pagination);
    }
    setFiltering(false);
  };

  // // // Change Page Logic
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    fetchOrgs(temp);
  };

  // // // Change organization status modal
  const handleStatusChange = async (org) => {
    if (!granted?.some((g) => g?.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        { duration: 3000 }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of "${org.name}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: org.id, status: org.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  // // // Change organization status Logic
  const changeStatus = async (data) => {
    const res = await toggleOrgStatus(data);
    if (res?.data?.success === true) {
      await fetchOrgs(pagination);
    } else {
      handleErrors(res, navigate);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // //Delete organization modal
  const handleDeleteOrganization = (org) => {
    setModalOptions({
      header: "Delete Organization",
      body: `Are you sure you want to delete "${org.name}"?`,
      okay: "Delete",
      method: deleteOrganization,
      data: { id: org.id },
    });
    setShowOptionsModal(true);
  };

  // // //Delete organization logic
  const deleteOrganization = async (data) => {
    if (data.id) {
      const res = await deleteCharitableOrgById(data.id);
      if (res?.data?.success && res?.data?.data === 1) {
        await fetchOrgs(pagination);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate);
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // //Delete organization modal
  const handleRestoreOrganization = (org) => {
    setModalOptions({
      header: "Restore Organization",
      body: `Are you sure you want to restore "${org.name}"?`,
      okay: "Restore",
      method: restoreOrganization,
      data: { id: org.id },
    });
    setShowOptionsModal(true);
  };

  // // //Delete organization logic
  const restoreOrganization = async (data) => {
    if (data.id) {
      const res = await restoreCharitableOrg(data.id);
      if (res?.data?.success && res?.data?.data === 1) {
        const string = "status=2";
        await fetchOrgs(pagination, string);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate);
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = charitableOrgs.map((org) => {
      const statusBtn =
        `<button class=\"btn btn-sm status-btn ${org.status === 1 ? "text-success" : "text-danger"}\" data-id=\"${org.id}\" title="change status">` +
        `${org.status === 1 ? "Active" : "Inactive"}</button>`;

      let actions = ``;
      if (filters !== "2") {
        actions +=
          `<button class=\"btn btn-sm btn-outline-success view-btn me-1\" data-id=\"${org.id}\" title=\"View\">` +
          `<i class=\"fa fa-eye\"></i></button>`;
      }

      if (granted.some((g) => g.type === "update") && filters !== "2") {
        actions +=
          `<button class=\"btn btn-sm btn-outline-primary edit-btn me-1\" data-id=\"${org.id}\" title=\"Edit\">` +
          `<i class=\"fa fa-pencil-alt\"></i></button>`;
      }
      if (
        granted.some((g) => g.type === "delete") &&
        org.status === 0 &&
        filters !== "2"
      ) {
        actions +=
          `<button class=\"btn btn-sm btn-outline-danger delete-btn\" data-id=\"${org.id}\" title=\"Delete\">` +
          `<i class=\"fas fa-trash-alt\"></i></button>`;
      }
      if (filters === "2") {
        actions +=
          `<button class=\"btn btn-sm btn-outline-danger restore-btn\" data-id=\"${org.id}\" title=\"restore\">` +
          `<i class="fa-solid fa-rotate-right"></i></button>`;
      }

      return [
        org.name,
        org.email,
        org.website,
        org.phone,
        org.founded,
        statusBtn,
        actions,
      ];
    });

    const config = {
      data: rows,
      columns: [
        { title: "Name" },
        { title: "Email" },
        { title: "Website" },
        { title: "Phone" },
        { title: "Founded" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }

    // Event bindings
    $table.off("click", ".view-btn").on("click", ".view-btn", function () {
      navigate(`/CharitableOrganization/details/${$(this).data("id")}`);
    });
    $table.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      navigate(`/CharitableOrganization/details/${$(this).data("id")}`);
    });
    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const org = charitableOrgs.find((o) => o.id === id);
      if (!org.deletedAt) {
        handleStatusChange(org);
      } else {
        toast.info("Cannot change status of a deleted record!", {
          duration: 3000,
        });
      }
    });
    $table.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const org = charitableOrgs.find((o) => o.id === id);
      handleDeleteOrganization(org);
    });
    $table
      .off("click", ".restore-btn")
      .on("click", ".restore-btn", function () {
        const id = $(this).data("id");
        const org = charitableOrgs.find((o) => o.id === id);
        handleRestoreOrganization(org);
      });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [charitableOrgs, granted, filters]);

  return (
    <div className="container py-4 text-light bg-dark rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-8 row">
          <div className="col-md-5">
            <Form.Control
              type="text"
              placeholder="Search Organizations..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="bg-dark text-light border-light input-placeholder-light"
            />
          </div>
          <div className="col-md-5">
            <Form.Select
              name="status"
              value={filters}
              onChange={(e) => {
                fetchFilteredOrgs(e);
              }}
              className="bg-dark border-light text-light"
            >
              <option value="3">Active & Inactive</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
              <option className="text-danger" value="2">
                Deleted
              </option>
            </Form.Select>
          </div>
          <div className="col-md-2">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <div className="row ">
                <Button
                  title="Reset Filters And Rrfresh Records"
                  className="btn btn-success"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-4 text-end">
          {granted.some((g) => g.type === "create") && (
            <Button
              title="Add New Organization"
              className="btn btn-success"
              onClick={() => {
                navigate("/CharitableOrganization/add");
              }}
            >
              <i className="bi bi-plus-circle"></i> Add New Organization
            </Button>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-dark table-striped w-100"
        />

        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      {/* <AddEditOrganizationModal
        showModal={showModal}
        setShowModal={setShowModal}
        selectedOrganization={selectedOrganization}
        setSelectedOrganization={setSelectedOrganization}
        setCharitableOrgs={setCharitableOrgs}
      /> */}
      {/* <OrganizationDetailsModal
        showDetailModal={showDetailsModal}
        seShowDetailmodal={setShowDetailsModal}
        organization={orgForDetails}
        setOrgForDetails={setOrgForDetails}
      /> */}
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default OrganizationList;
